import React, { Component } from "react";
import Calendar from "../../waybee-ui/Calendar/Calendar";
import TeacherService from "../../services/TeacherService";

class Schedule extends Component {
  constructor() {
    super();
    this.state = {
      schedule: {}
    };
  }

  async componentDidMount() {
    this.options().then(res => {
      this.setState({ schedule: res });
    });
  }

  options = async () => {
    const userInfo = JSON.parse(localStorage.getItem("userExternalInfo"));
    return {
      views: {
        timeGridWeek: {
          titleFormat: { month: "long", day: "numeric" },
          slotLabelFormat: { hour: "numeric", minute: "2-digit" },
          columnHeaderFormat: { weekday: "short", day: "numeric" }
        },
        timeGridDay: {
          titleFormat: { month: "long", day: "numeric", weekday: "short" }
        }
      },
      allDaySlot: false,
      events: async (info, successCallback, failureCallback) => {
        try {
          const scheduleData = await TeacherService.getSchedule(
            info.startStr,
            info.endStr,
            userInfo.codPessoa
          );
          successCallback(scheduleData);
        } catch (e) {
          failureCallback(e);
        }
      },
      defaultView: "timeGridWeek"
    };
  };

  render() {
    const { schedule } = this.state;
    return (
      <div>
        <Calendar options={schedule} />
      </div>
    );
  }
}

export default Schedule;
